import { schema, types } from 'papr'

export const emailHistorySchema = schema(
	{
		deliveryId: types.string({ required: true }),
		totalCount: types.number(),
		opens: types.number(),
		clicks: types.number(),
		publication: types.objectId(),
		posts: types.array(types.objectId()),
		dateAdded: types.date(),
	},
	{
		timestamps: true,
		defaults: {
			totalCount: 0,
			opens: 0,
			clicks: 0,
		},
	},
)

export type EmailHistoryDocument = (typeof emailHistorySchema)[0]
export type EmailHistorySchemaOptions = (typeof emailHistorySchema)[1]
